import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SharedService {

    private emitResellerChangeSource = new Subject<any>();
    changeResellerEmitted$ = this.emitResellerChangeSource.asObservable();
    emitResellerChange(change: any) {
        this.emitResellerChangeSource.next(change);
    }

    private emitChangeSource = new Subject<any>();
    changeEmitted$ = this.emitChangeSource.asObservable();
    emitChange(change: any) {
        this.emitChangeSource.next(change);
    }
    
    private emitDeptChangeSource = new Subject<any>();
    changeDeptEmitted$ = this.emitDeptChangeSource.asObservable();
    emitDeptChange(change: any) {
        this.emitDeptChangeSource.next(change);
    }


    private emitCardNoSource = new Subject<any>();
    changeCardNoEmitted$ = this.emitCardNoSource.asObservable();
    emitCardNoChange(change: any) {
        this.emitChangeSource.next(change);
    }

    private emitActiveCardsChangeSource = new Subject<any>();
    changeActiveCardsEmitted$ = this.emitActiveCardsChangeSource.asObservable();
    emitActiveCardChange(change: any) {
        this.emitActiveCardsChangeSource.next(change);
    }
}
